import { useMutation } from "react-query";
import { Auth } from "shared/@auth/Auth";
import { flattenFeedItemForPut } from "NewsAdmin/utils/flattenFeedItemForPut";
import { flattenFeedItemForPost } from "NewsAdmin/utils/flattenFeedItemForPost";

export function useEditFeedPage() {
  const { makeAuthedRequest } = Auth.useContainer();

  // Final delete → DELETE /feed/:id
  const deleteFeedItem = useMutation(({ id }) => {
    return makeAuthedRequest(`feed/item/delete/${id}`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    }).then(async (res) => {
      if (!res.ok) {
        let message = "Unknown error";
        try {
          const err = await res.json();
          message = err.message || message;
        } catch {}
        throw new Error(message);
      }
    });
  });
  
  // Final Create → POST /feed
  const createFeedItem = useMutation(({ feedItem, diamondsList, groupsList, isDraft }) => {
    const flattened = flattenFeedItemForPost({
      feedItem,
      diamondsList,
      groupsList,
      isDraft,
    });
    // console.log(flattened)

    // console.log("POST starting...", flattened);
    // console.log("Start:", new Date().toISOString());

    return makeAuthedRequest(`feed`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...flattened,
      }),
    }).then(async (res) => {
      // console.log("POST response received", res);
      // console.log("End:", new Date().toISOString());

      if (res.ok) {
        try {
          return await res.json();
        } catch {
          return {}; // fallback if no JSON
        }
      } else {
        let message = "Unknown error";
        try {
          const err = await res.json();
          message = err.message || message;
        } catch {}
        throw new Error(message);
      }
    });
  });

  // Final Save → PUT /feed
  const saveFeedItem = useMutation(({ feedItem, diamondsList, groupsList }) => {
    const flattened = flattenFeedItemForPut({ feedItem, diamondsList, groupsList });

    // console.log("PUT starting...", flattened);
    // console.log("Start:", new Date().toISOString());

    return makeAuthedRequest(`feed`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...flattened,
        isEditingDraft: false,
        draftVersion: null,
      }),
    }).then(async (res) => {
      // console.log("PUT response received", res);
      // console.log("End:", new Date().toISOString());

      if (res.ok) {
        try {
          return await res.json();
        } catch {
          return {}; // fallback if no JSON
        }
      } else {
        let message = "Unknown error";
        try {
          const err = await res.json();
          message = err.message || message;
        } catch {}
        throw new Error(message);
      }
    });
  });

  // Save as Draft → PUT /feed/draft
  const saveAsDraft = useMutation(({ feedItem, diamondsList, groupsList }) => {
    const flattened = flattenFeedItemForPut({ feedItem, diamondsList, groupsList });

    return makeAuthedRequest(`feed/draft`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: flattened.id,
        isEditingDraft: true,
        draftVersion: flattened,
      }),
    }).then(async (res) => {
      if (res.ok) {
        try {
          return await res.json();
        } catch {
          return {};
        }
      } else {
        let message = "Unknown error";
        try {
          const err = await res.json();
          message = err.message || message;
        } catch {}
        throw new Error(message);
      }
    });
  });

  return {
    saveFeedItem: saveFeedItem.mutate,
    saveAsDraft: saveAsDraft.mutate,
    createFeedItem: createFeedItem.mutate,
    deleteFeedItem: deleteFeedItem.mutate,
    isSaving:
      saveFeedItem.isLoading ||
      saveAsDraft.isLoading ||
      createFeedItem.isLoading ||
      deleteFeedItem.isLoading,
  };
}
